import { PageContent, PageSection } from '@/pages/umeds/order-medication/OrderMedication.styles';
import { Box, Typography } from '@montugroup/design-system';
import { Skeleton, styled } from '@mui/material';
import ReviewNewScriptCard from './ReviewNewScriptCard';
import type { ReviewNewScriptProps } from './types';

const SkeletonCard = styled(Box)(({ theme }) => ({
  border: '2px solid',
  borderRadius: theme.shape.borderRadius,
  borderColor: theme.palette.action.disabledBackground,
  marginBottom: theme.spacing(3),
  padding: `${theme.spacing(1)} ${theme.spacing(4)}`,
  flexDirection: 'row',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'space-between',
}));

export function ReviewNewScript({ script }: ReviewNewScriptProps) {
  return (
    <>
      {script.length === 0 && (
        <PageContent data-testid="loading-skeleton">
          <PageSection sx={{ gridArea: 'error' }} />
          <PageSection sx={{ gridArea: 'title' }}>
            <Skeleton variant="text" width={250} />
          </PageSection>
          <PageSection sx={{ gridArea: 'products' }}>
            <SkeletonCard>
              <Skeleton variant="text" height={42} width="100%" sx={{ marginTop: '1rem' }} />
            </SkeletonCard>
            <SkeletonCard>
              <Skeleton variant="text" height={42} width="60%" sx={{ marginTop: '1rem' }} />
            </SkeletonCard>
          </PageSection>
        </PageContent>
      )}
      {script.length > 0 && (
        <>
          <PageSection sx={{ gridArea: 'title' }}>
            <Typography fontWeight="bold" variant="h5">
              {script.length > 1 ? `Review ${script.length} scripts` : 'Review 1 script'}
            </Typography>
          </PageSection>
          <PageSection>
            {script.length > 0 && script.map((product, index) => <ReviewNewScriptCard key={index} {...product} />)}
          </PageSection>
        </>
      )}
    </>
  );
}
